import { AxiosError, InternalAxiosRequestConfig } from 'axios';

import { appEnv } from '@/app/config/env';
import { storageKeys } from '@/app/constants/storageKeys';
import { storage } from '@/infra/protocols/storage';

const onRequest = (config: InternalAxiosRequestConfig) => {
  const accessToken = storage.get(storageKeys.ACCESS_TOKEN).trim();

  if (!config.headers?.['Content-Type']) {
    config.headers['Content-Type'] = 'application/json';
  }
  if (!config.headers?.['x-api-key'] && appEnv.apiKey) {
    config.headers['x-api-key'] = appEnv.apiKey;
  }
  if (!config.headers?.['Authorization'] && accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }

  return config;
};

const onRequestError = (error: AxiosError) => Promise.reject(error as Error);

export { onRequest, onRequestError };
